/// <amd-module name="Build/Admin/Pool/Components/Description" />
import * as React from "react";

import { MarkdownRendererOptions } from "VSS/Features/Markdown/MarkdownRendererContracts";
import { shortcutCommands } from "VSS/Features/MarkdownEditor/Commands/Shortcut";
import { MarkdownPreview, MarkdownTextField } from "VSS/Features/MarkdownEditor/Components";

import { Spinner, SpinnerSize } from "VSSUI/Spinner";

import { StoreStatus } from "Build/Admin/Common/Constants";

import * as Resources from "Build/Admin/Pool/Resources";

export interface IDescriptionProps {
    agentPoolDescription: string;
    status: StoreStatus;
    editable: boolean;
    onChanged(agentPoolDescription: string): void;
}

export class Description extends React.PureComponent<IDescriptionProps> {
    private static markdownOptions: MarkdownRendererOptions = {
        breaks: true,
        linkify: true,
        typographer: false,
        enableEmoji: true,
        hideExternalImageIcon: true,
        enableImageSize: true,
        enableKatex: false,
        linkifyTlds: ["biz", "com", "edu", "gov", "net", "org", "pro", "web", "aero", "asia", "coop", "info", "museum", "name", "shop", "рф", "io"]
    };

    constructor(props: IDescriptionProps) {
        super(props);
    }

    public render(): JSX.Element {
        if (this.props.status === StoreStatus.Loaded) {
            if (this.props.editable) {
                return (
                    <MarkdownTextField
                        formItemClassName="flex-grow"
                        shortcutCommands={shortcutCommands}
                        value={this.props.agentPoolDescription}
                        onChange={poolDescription => this.props.onChanged(poolDescription)}
                        rows={10} />
                );
            }
            else {
                return (
                    <MarkdownPreview
                        className="flex-grow"
                        options={Description.markdownOptions}
                        value={this.props.agentPoolDescription || Resources.PoolDescriptionNotFound} />
                );
            }
        }
        else {
            return <Spinner className="pool-details-spinner scroll-hidden flex-grow flex-self-center" size={SpinnerSize.large} />;
        }
    }
}
